import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";

export function LayoutComponent({ children, context }) {
    // const { mediaId } = useParams();
    const location = useLocation();
    const { mediaId } = useParams();

    useEffect(() => {
        // const mediaId = location.pathname.split('/')[1];
        const queryParams = new URLSearchParams(location.search);
        const name = queryParams.get("name");
        const lang = queryParams.get("lang") === "zh" ? "ch" : queryParams.get("lang");
        const from_eng = queryParams.get("from_eng");
        const video = queryParams.get("video");
        const subtitles = queryParams.get("subtitles");
        const voicing = queryParams.get("voicing");
        const time = parseInt(queryParams.get("st") || "0");
        // Extract the folder from queryParams each time the effect runs
        const currentFolder = Number(queryParams.get("folder"));
        // Check and update context only if the folder has changed
        if (mediaId && context.state["mediaId"] !== mediaId) {
            context.handles.setMediaId(mediaId);
            context.handles.setName(name);
            context.handles.setFolder(currentFolder);
            context.handles.setTime(time);
        }
        // Всегда обновляем язык при изменении URL
        if (lang && context.state["lang"] !== lang) {
            context.handles.setLang(lang);
            if (context.handles.setToLang) {
                context.handles.setToLang(lang);
            }
        }
        const originalLang = from_eng === "1" ? "en" : "ru";
        if (!lang && context.state["lang"] !== originalLang) {
            // No language in the URL means the original itself is open. It used to fall back to
            // a hardcoded "ru" with toLang "english" — two different languages describing one
            // screen, and plainly wrong on a lecture whose original is English, where every save
            // then named a ru_* pair the lecture does not have. Following the original keeps the
            // state coherent and makes "no lang = editing the source" true for both kinds.
            context.handles.setLang(originalLang);
            if (context.handles.setToLang) {
                context.handles.setToLang(originalLang);
            }
        }
        context.handles.setOriginalLang(originalLang);
        context.handles.setVideo(video ? "sm" : "");
        // context.handles.setSubtitleMode(subtitles ? true : false);

        if (currentFolder && context.state["folder"] !== currentFolder) {
            context.handles.setFolder(currentFolder);
            if (context.state.playing) {
                context.handles.setPlaying(false);
            }
            context.handles.setPlayOriginalStart(0);
        }
        context.handles.setVoicingSpacesOn(voicing === "1");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]); // Depend on location.search to re-run the effect when query params change

    return (
        <div
            className={location.pathname.startsWith("/translate/") ? "App-translate b0t" : "App b0"}
        >
            {children}
        </div>
    );
}

export const Layout = React.memo(LayoutComponent);
